import Vue from "vue";
import * as MSAL from "@azure/msal-browser";
import Vuelidate from "vuelidate";
import { InlineSvgPlugin } from "vue-inline-svg";
import VueCookies from "vue-cookies";

import App from "./App.vue";
import clickOutside from "./directives/click-outside";

import i18n from "./factories/i18n.factory";
import store from "./factories/store.factory";
import router from "./factories/router.factory";

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(InlineSvgPlugin);
Vue.use(VueCookies);
Vue.$cookies.config("90d");
Vue.directive("click-outside", clickOutside);

export let msal;

export const scopes = [process.env.VUE_APP_MSAL_SCOPE];

try {
  msal = new MSAL.PublicClientApplication({
    auth: {
      clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
      authority: process.env.VUE_APP_MSAL_AUTHORITY,
      redirectUri: process.env.VUE_APP_REDIRECT_URI,

      knownAuthorities: ["rowab2cdev.b2clogin.com", "rowab2cprod.b2clogin.com"]     }
  });
  window.msal = msal;
} catch (e) {
  //MSAL login error
}


const redirectCallback = error => {
  if (error) {
    if (error.errorMessage.includes("AADB2C90091")) {
      msal.loginRedirect({ scopes });
    }
    if (error.errorMessage.includes("AADB2C90118")) {
      msal.loginRedirect({
        authority: process.env.VUE_APP_MSAL_FORGOT_PASSWORD_AUTHORITY,
        scopes
      });
    }
  }
};

msal.handleRedirectPromise()
  .then(() => {
    const accounts = msal.getAllAccounts();

    if (accounts.length === 0) {
      //No accounts found – clearing cache and redirecting...
      sessionStorage.clear();
      localStorage.clear();
      msal.loginRedirect({ scopes });
      return;
    }

    msal.acquireTokenSilent({
      scopes,
      account: accounts[0]
    }).then((tokenResponse) => {
      sessionStorage.setItem("access_token", tokenResponse.accessToken);
      Vue.$cookies.set(
        "aad_b2c_session",
        "active",
        process.env.VUE_APP_IDLE_LOGOUT_TIME
      );
      //Starting App...
      new Vue({
        i18n,
        store,
        router,
        render: h => h(App)
      }).$mount("#app");

    }).catch(() => {
      //Silent token error
      sessionStorage.clear();
      localStorage.clear();
      msal.loginRedirect({ scopes });
    });
  })
  .catch(redirectCallback);